"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNone = exports.isNone = exports.createSome = exports.isSome = void 0;
function isSome(input) {
    return input.ok;
}
exports.isSome = isSome;
function createSome(val) {
    var r = {
        ok: true,
        val: val,
    };
    return r;
}
exports.createSome = createSome;
function isNone(input) {
    return !input.ok;
}
exports.isNone = isNone;
function createNone() {
    var r = {
        ok: false,
        // XXX: We need to fill with `null` to improve the compatibility with Next.js
        // see https://github.com/karen-irc/option-t/pull/1256
        val: null,
    };
    return r;
}
exports.createNone = createNone;
